import { baseAPI } from "../../baseApi";
import { tagsTypes } from "../../tagsTypes";

export const accountDetailSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    postAccountDetail: builder.mutation({
      query: (data) => ({
        url: "supplier-save-bank-detail",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_USER_PROFILE],
    }),
  }),
});

export const { usePostAccountDetailMutation } = accountDetailSlice;
